import React from 'react';

import { HStack, Text } from '@chakra-ui/react';

import { Button, Icon } from 'components';
import { ButtonProps } from 'components/buttons/default';

export default function EditButton(props: ButtonProps) {
  return (
    <HStack>
      <Button
        _hover={{
          bg: 'primary.700',
          color: 'white.default',
        }}
        bg="white.default"
        borderRadius={50}
        h={8}
        _active={{
          color: 'white.default',
        }}
        color="gray.500"
        {...props}>
        <Text variant="xSmallSemiBold">Editar</Text><Icon
          ml={2}
          name="edit"
        />
      </Button>
    </HStack>
  );
}
